
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'cta-hero',
  components: {
    SpeedkitPicture,
  },
  props: {
    ctaIcon: true,
    title: {
      type: String,
      require: true,
    },
    description: {
      type: String,
      require: true,
    },
    tool: {
      type: String,
      require: false,
    },
    cta: {
      type: Array,
      require: false,
    },
    image: {
      type: Object,
      require: false,
    },
  },
}
